export default __webpack_public_path__ + "static/banking-72ea208895a6dbd6f3a1f332918ec7b6.webp";